import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useOnboarding } from '../../hooks/useOnboarding';
import { isTipDismissed } from '../../utils/onboarding';
import { ContextualTip } from './OnboardingCards';

interface FeatureTipProps {
  tipId: string;
  children: React.ReactNode;
  className?: string;
  /** When false, tip never shows (e.g. visitor on public page). */
  enabled?: boolean;
}

/**
 * Authenticated first-visit tip. Loads onboarding state once via useOnboarding.
 * Safe to mount on multiple pages; only one tipId should be active per page.
 */
export const FeatureTip: React.FC<FeatureTipProps> = ({
  tipId,
  children,
  className,
  enabled = true,
}) => {
  const { isAuthenticated } = useAuth();
  const { state, loading, dismissTip } = useOnboarding();

  if (!enabled || !isAuthenticated || loading) return null;
  if (isTipDismissed(state, tipId)) return null;

  return (
    <ContextualTip tipId={tipId} onDismiss={(id) => void dismissTip(id)} className={className}>
      {children}
    </ContextualTip>
  );
};

export default FeatureTip;
